<template>
  <div id="container">
    <div class="sub-container">
      <div id="main-page">
        <div id="header">
          <img src="@/assets/theme/header.png">
        </div>
        <div id="content">
          <div id="c-content">
            <TodayResult />
            <HistoryResults />
          </div>
          <div id="r-content">
            <div class="box-banner">
              <img src="@/assets/theme/Bn1.png" class="banner">
            </div>
            <div class="box-banner">
              <img src="@/assets/theme/Bn2.png" class="banner">
            </div>
            <div class="box-banner">
              <img src="@/assets/theme/Bn3.png" class="banner">
            </div>
            <div class="box-banner">
              <img src="@/assets/theme/b4.png" class="banner">
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "@/moment"

import TodayResult from './components/TodayResult.vue'
import HistoryResults from './components/HistoryResults.vue'

export default {
  components: {
    TodayResult,
    HistoryResults
  },
  data() {
    return {
      timeNow: moment().format("HH:mm:ss"),
      timeInterval: null,
      News: []
    }
  },
  computed: {
    TopNews() {
      return this.News.slice(0, 3)
    }
  },
  methods: {
  },
  created() {
    this.timeInterval = setInterval(() => {
      this.timeNow = moment().format("HH:mm:ss")
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timeInterval)
  },
  filters: {
    date(param) {
      return moment(param).format("DD/MM/YYYY HH:MM")
    }
  }
}

</script>
<style lang="scss">
body {
  background-color: #FFF;
  //background: #fff url('../assets/theme/bg.png') repeat-x left 0;
}

.clearfix {
  clear: both;
}

#container {
  border-top: 15px solid #011B5C;
  border-bottom: 20px solid #011B5C;

  .sub-container {
    border-top: 5px solid #B00000;
    border-bottom: 10px solid #B00000;
  }
}

#main-page {
  width: 1000px;
  max-width: 100%;
  margin: 5px auto;
  background-color: #FFF;
  padding-bottom: 0px;

  #header {
    margin-bottom: 10px;

    img {
      max-width: 100%;
    }
  }

  #content {
    padding: 0px;
    margin: 0px;
    display: flex;

    #c-content {
      //float: left;
      width: 670px;
      margin: 0px;

      .box-news {
        margin-top: 15px;
        margin-bottom: 10px;

        .box-list-news {
          border-bottom: 1px dotted #e2e2e2;
          padding: 10px 0 5px;

          h6.title-news-top {
            font-weight: bold;

            a {
              color: #0077cc;
            }
            a:hover {
              color: #000000;
            }
            a:visited {
              color: #0077cc;
            }
          }

          .news-date {
            font-size: 11px;
            margin: 5px 0;
          }

          .more {
            a {
              color: #0077cc;
              font-weight: bold;
              float: right;
              background: transparent url('../assets/theme/i-more.jpg') no-repeat right 4px;
              font-weight: bold;
              font-style: italic;
              font-size: 12px;
              display: block;
              padding-right: 15px;
            }
            a:hover {
              color: #000;
            }
            a:visited {
              color: #0077cc;
            }
          }
        }
      }
    }

    #r-content {
      //float: left;
      width: 315px;
      max-width: 100%;
      margin: 0px 0px 0px 15px;

      .box-banner {
        margin-bottom: 10px;
        text-align: center;

        .banner {
          width: 100%;
          max-width: 100%;
        }
      }

      .box-news {
        margin-top: 10px;

        .box-title {
          background: #fff url('../assets/theme/news-header.png') no-repeat left 0;
          clear: both;
          overflow: hidden;
          height: 35px;
          padding-left: 0;
          display: block;
          border: 0;

          border-top: 0px #fff solid;
          border: 0 solid #ccc;
          border-width: 1px 1px 0 0;
          border-bottom: 1px solid #CCCCCC;

          h5 {
            line-height: 32px;
            padding-left: 10px;
            height: 24px;
            color: #07c;
            font-weight: bold;
            float: left;
          }

          .social-button {
            float: right;
            padding-right: 10px;
            padding-top: 3px;
            font-size: 18px;

            .fa-facebook-f {
              color: #0077cc;
            }

            .fa-youtube {
              color: red;
            }
          }
        }

        .box-content {
          background-image: none;
          border-top: 0px #fff solid;
          border: 0 solid #ccc;
          border-width: 0 1px 0 1px;
          border-bottom: 1px solid #CCCCCC;

          .top-news {
            overflow: hidden;
            clear: both;
            padding: 10px;

            li {
              overflow: hidden;
              display: block;
              margin-bottom: 5px;
              padding-bottom: 5px;
              padding-left: 15px;
              line-height: 21px;
              font-size: 13px;
              height: auto;
              border-bottom: 1px dotted #e2e2e2;
              background: url('../assets/theme/icon-story.gif') no-repeat scroll left 3px transparent;

              a {
                color: #0077cc;
                text-decoration: none;
              }

              a:visited {
                color: #0077cc;
                text-decoration: none;
              }

              a:hover {
                color: #000000;
              }

              .time-news {
                font-size: 11px;
                display: inline;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #main-page {
    padding: 0 10px;
  }
  #main-page #content {
    display: block;
  }
  #main-page #content #c-content {
    width: 100%;
  }
  #main-page #content #r-content {
    width: 100%;
    margin: 15px 0;
  }
  #main-page #content #r-content .box-banner {
    margin-bottom: 10px;
  }
}
</style>
